// removed by extract-text-webpack-plugin
module.exports = {"readOnly":"c-IngridWidget2__readOnly","message":"c-IngridWidget2__message"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/IngridWidget2/IngridWidget2.scss
// module id = 918
// module chunks = 0